/* eslint-disable max-depth */
// 处理正则表达式
export const deleteStartPattern = (reg?: string) => {
  const temp = reg;
  // 删除开始匹配符^
  const has = temp?.indexOf('^') === 0;
  const formatReg = has ? temp?.substring(1, temp.length) : temp;
  return formatReg;
};
export const deleteEndPattern = (reg?: string) => {
  const temp = reg;
  // 删除结束匹配符$
  const has = temp?.length && temp?.indexOf('$') === temp.length - 1;
  const formatReg = has ? temp?.substring(0, temp.length - 1) : temp;
  return formatReg;
};
export const findOverlapReg = (regexList: RegExp[]): RegExp[] => {
  if (!regexList?.length) {
    return [];
  }
  const overlaps: RegExp[] = [];

  for (let i = 0; i < regexList.length; i++) {
    try {
      const regex = new RegExp(regexList[i]);
      for (let j = 0; j < overlaps.length; j++) {
        if (regex.test(overlaps[j].toString())) {
          overlaps.push(regexList[i]); // 如果有重叠，将当前正则表达式添加到重叠列表中
          overlaps.push(regexList[j]);
          break;
        }
      }

      if (!overlaps.includes(regex)) {
        // 如果没有重叠，将当前正则表达式与之前的所有正则表达式进行比较
        for (let j = 0; j < i; j++) {
          if (regex.test(regexList[j].toString())) {
            overlaps.push(regex); // 如果有重叠，将当前正则表达式添加到重叠列表中
            break;
          }
        }
      }
    } catch (e) {}
  }
  return Array.from(new Set(overlaps));
};

export const validateRegex = regexStr => {
  try {
    new RegExp(regexStr); // 构造 RegExp 对象来检查正则表达式的语法是否正确
    return true; // 正则表达式合法
  } catch (e) {
    return false; // 正则表达式不合法
  }
};

export const filterHtmlText = htmlString => {
  return htmlString?.replace(/<[^>]+>/g, '')?.replace(/&(nbsp|amp|quot|lt|gt);/g, '') || '';
};
